@if (loading()) {
	<activar-skeleton [lines]="4" />
} @else if (error()) {
	<div class="flex flex-col gap-3 items-start">
		<p>No pudimos cargar tus API keys.</p>
		<activar-button data-testid="retry" text="Reintentar" fill="out" color="primary" (click)="retry.emit()" />
	</div>
} @else if (rows().length === 0) {
	<div class="flex flex-col gap-3 items-start">
		<p>Todavía no creaste ninguna API key</p>
		<activar-button data-testid="empty-create" text="Crear" fill="solid" color="primary" (click)="create.emit()" />
	</div>
} @else {
	<div class="overflow-x-auto">
		<table class="w-full text-left">
			<thead>
				<tr class="border-b border-gray-200 text-sm text-gray-500">
					<th class="py-2 pr-4 font-medium">Nombre</th>
					<th class="py-2 pr-4 font-medium">Prefijo</th>
					<th class="py-2 pr-4 font-medium">Creada</th>
					<th class="py-2 pr-4 font-medium">Último uso</th>
					<th class="py-2 pr-4 font-medium">Vence</th>
					<th class="py-2 pr-4 font-medium">Estado</th>
					<th class="py-2 font-medium">Acciones</th>
				</tr>
			</thead>
			<tbody>
				@for (row of rows(); track row.id) {
					<tr class="border-b border-gray-100">
						<td class="py-3 pr-4 font-semibold" data-testid="name">{{ row.name }}</td>
						<td class="py-3 pr-4 font-mono text-sm" data-testid="prefix">act_{{ row.prefix }}_…</td>
						<td class="py-3 pr-4 text-sm" data-testid="created">{{ row.createdAtDate | date: 'dd/MM/yyyy HH:mm' }}</td>
						<td class="py-3 pr-4 text-sm" data-testid="last-used">
							{{ row.lastUsedAtDate ? (row.lastUsedAtDate | date: 'dd/MM/yyyy HH:mm') : 'Nunca' }}
						</td>
						<td class="py-3 pr-4 text-sm" data-testid="expires">
							{{ row.expiresAtDate ? (row.expiresAtDate | date: 'dd/MM/yyyy') : 'Nunca' }}
						</td>
						<td class="py-3 pr-4">
							<span
								data-testid="status"
								class="text-xs rounded-full px-2 py-0.5"
								[class]="row.expired ? 'text-red-700 bg-red-100' : 'text-primary-900 bg-primary-100'">
								{{ row.expired ? 'Vencida' : 'Activa' }}
							</span>
						</td>
						<td class="py-3">
							<activar-button
								data-testid="delete"
								text="Eliminar"
								fill="out"
								color="danger"
								(click)="delete.emit(row)" />
						</td>
					</tr>
				}
			</tbody>
		</table>
	</div>
}
